// Persists an in-progress receipt scan so it survives an app reload
// (e.g. Chrome/PWA reloading the page after the camera backgrounds the app).
const DB_NAME = "sliply";
const STORE = "pending";
const KEY = "scan";
const FLAG = "sliply_pending_scan";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function savePendingScan(files) {
  try {
    const db = await openDb();
    const payload = files.map((f) => ({ blob: f, name: f.name, type: f.type }));
    await new Promise((res, rej) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.objectStore(STORE).put(payload, KEY);
      tx.oncomplete = res;
      tx.onerror = () => rej(tx.error);
    });
    sessionStorage.setItem(FLAG, "1");
  } catch (e) {
    /* best effort */
  }
}

export async function loadPendingScan() {
  try {
    const db = await openDb();
    const payload = await new Promise((res, rej) => {
      const tx = db.transaction(STORE, "readonly");
      const rq = tx.objectStore(STORE).get(KEY);
      rq.onsuccess = () => res(rq.result);
      rq.onerror = () => rej(rq.error);
    });
    if (!payload || !payload.length) return null;
    return payload.map((p) => new File([p.blob], p.name || "receipt.jpg", { type: p.type || "image/jpeg" }));
  } catch (e) {
    return null;
  }
}

export async function clearPendingScan() {
  sessionStorage.removeItem(FLAG);
  try {
    const db = await openDb();
    await new Promise((res) => {
      const tx = db.transaction(STORE, "readwrite");
      tx.objectStore(STORE).delete(KEY);
      tx.oncomplete = res;
      tx.onerror = res;
    });
  } catch (e) {
    /* best effort */
  }
}

export function hasPendingScan() {
  return sessionStorage.getItem(FLAG) === "1";
}
